import { render, staticRenderFns } from "./Step6Notifications.vue?vue&type=template&id=6b439d3e&scoped=true"
import script from "./Step6Notifications.vue?vue&type=script&lang=js"
export * from "./Step6Notifications.vue?vue&type=script&lang=js"
import style0 from "./Step6Notifications.vue?vue&type=style&index=0&id=6b439d3e&prod&lang=css"
import style1 from "./Step6Notifications.vue?vue&type=style&index=1&id=6b439d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b439d3e",
  null
  
)

export default component.exports